import { j as a } from "./jsx-runtime.DGlMoOmv.js";
import * as o from "react";
import { P as n } from "./index.DMLWxr4u.js";
import { c as d } from "./index.C4-GUKyp.js";
import { FormattedMessage as f } from "react-intl";
import { T as c } from "./Text.BGhoO_e3.js";
import { c as p } from "./index.CxSWpsOB.js";
var b = "Label", i = o.forwardRef((t, r) => /* @__PURE__ */ a.jsx(
  n.label,
  {
    ...t,
    ref: r,
    onMouseDown: (e) => {
      e.target.closest("button, input, select, textarea") || (t.onMouseDown?.(e), !e.defaultPrevented && e.detail > 1 && e.preventDefault());
    }
  }
));
i.displayName = b;
var l = i;
const u = d("tw-body-2-m tw-inline-block peer-disabled:tw-pointer-events-none peer-disabled:tw-text-gray-500 tw-mb-0"), x = o.forwardRef(({
  className: t,
  required: r,
  children: e,
  ...s
}, m) => /* @__PURE__ */ a.jsxs(l, { ref: m, className: p(u({
  className: t
})), "aria-required": r, ...s, children: [
  e,
  r && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    " ",
    /* @__PURE__ */ a.jsxs(c, { className: "tw-text-gray-600", typeface: "body-2", children: [
      "(",
      /* @__PURE__ */ a.jsx(f, { id: "+gRnOa", defaultMessage: [{
        type: 0,
        value: "required"
      }] }),
      ")"
    ] })
  ] })
] }));
x.displayName = l.displayName;
export {
  x as L
};
//# sourceMappingURL=Label.h3I9kFDT.js.map
